import React, { useEffect, useState } from 'react';
import { Box, TableCell, TablePagination, Typography, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { obtenerNumeroParking } from '@utils/parkingFunctions';
import { useWindowSize } from '@utils/resize';
import CircleIcon from "@mui/icons-material/Circle";
import { obtenerEstadoTrafico } from '@utils/estadoTrafico';
import BasicTextFields from '@componentes/Filters/InputText';
import BasicSelect from '@componentes/Filters/Select';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

interface TablaEspecialProps {
    info: { id: number, descripcion: string, direccion?: string, libres?: string, nivel?: number, imagen?: string, enlace?: string, carga?: number, icon?: boolean, forzadura?: number }[]
    setMarked?: (id: string) => void;
    tipo?: string
}

const TablaEspecial: React.FC<TablaEspecialProps> = ({ info, setMarked, tipo }) => {
    const { width } = useWindowSize();
    const rootStyles = getComputedStyle(document.documentElement);
    const principalColor = rootStyles.getPropertyValue('--primary-color');
    const thirdColor = rootStyles.getPropertyValue('--fourth-color');
    const secondaryColor = rootStyles.getPropertyValue('--secondary-color');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [tableInfoAux, setTableInfoAux] = useState(info);
    const [tableInfoAuxDescri, setTableInfoAuxDescri] = useState(info);
    const [tableInfoAuxEstado, setTableInfoAuxEstado] = useState(info);
    const [nivelTrafico, setNivelTrafico] = useState(3)

    useEffect(() => {
        setTableInfoAux(info);
        setTableInfoAuxDescri(info);
        setTableInfoAuxEstado(info);
        setPage(0)
    }, [info]);
    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setNivelTrafico(config.NIVEL_TRAFICO)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const intersection = (): { id: number, descripcion: string, direccion?: string, libres?: string, nivel?: number, imagen?: string, enlace?: string, carga?: number }[] => {
        return info.filter(elem => (tableInfoAuxDescri.includes(elem) && tableInfoAuxEstado.includes(elem)));
    };

    useEffect(() => {
        const filteredData = intersection();
        setTableInfoAux(filteredData);
        setPage(0)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableInfoAuxDescri, tableInfoAuxEstado]);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 8));
        setPage(0);
    };

    return (
        <div style={{ display: tipo === 'Tipos de Incidencia' ? 'flex' : '', justifyContent: tipo === 'Tipos de Incidencia' ? 'center' : '', width: '100%' }}>
            <Box sx={{ bgcolor: secondaryColor, borderRadius: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: width < 1300 ? '10px' : '', width: tipo === 'Tipos de Incidencia' ? width < 1300 ? '100%' : '400px' : '100%' }}>
                <div style={{ width: '88%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px', marginBottom: tableInfoAux.length <= 8 ? '10px' : '' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: principalColor }}>
                        {!tipo &&
                            <Link className='link-subruta' style={{ marginLeft: '-5px', fontSize: '20px', color: principalColor, fontWeight: 'bold' }} to={'/aparcamientos'}>
                                Aparcamientos
                            </Link>}
                        {
                            tipo && <span style={{ marginLeft: tipo === 'Aparcamientos' ? '-5px' : '', fontSize: '20px', color: principalColor, fontWeight: 'bold' }}>{tipo}</span>
                        }
                    </Typography>
                    {
                        tipo === 'Estado de Tráfico' && <>
                            <BasicTextFields tableInfo={info} setTableInfo={setTableInfoAuxDescri} />
                            <BasicSelect tableInfo={info} setTableInfo={setTableInfoAuxEstado} />
                        </>
                    }
                    {(tableInfoAux.length > 8 || tipo === 'Estado de Tráfico') && width > 1300 && (
                        <TablePagination
                            rowsPerPageOptions={[8]}
                            component="div"
                            count={tableInfoAux.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelDisplayedRows={
                                ({ from, to, count }) => {
                                    return ''
                                }
                            }
                            sx={{
                                '& .MuiTablePagination-actions': {
                                    color: principalColor,
                                    gap: '4px',
                                },
                                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-selectIcon, & .MuiTablePagination-input, & .MuiTablePagination-displayedRows': {
                                    color: principalColor,
                                    fontSize: '10px',
                                },
                                '& .MuiTablePagination-toolbar': {
                                    minHeight: '40px', 
                                },
                                '&::-webkit-scrollbar': {
                                    display: 'none', 
                                },
                                '&': {
                                    scrollbarWidth: 'none',
                                },
                            }}
                        />
                    )}
                </div>
                {tableInfoAux.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableCell key={index} sx={{ bgcolor: thirdColor, borderRadius: 1, padding: '10px', display: 'flex', justifyContent: 'space-between', width: '86.5%', margin: '5px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'flex-start', maxWidth: !tipo ? '70%' : width > 1300 ? '90%' : '80%' }}>
                            <div style={{ display: 'flex', alignItems: 'center'  }}>
                                {
                                    row.icon && <a className="custom-link" href={row.enlace} style={{ marginRight: '20px' }} download={width > 1300 ? false : true}>
                                        <PictureAsPdfIcon sx={{color: principalColor}}/>
                                    </a>
                                }
                                <Tooltip title={row.descripcion} arrow enterTouchDelay={0}>
                                    <span style={{ fontWeight: 'bold', cursor: setMarked ? 'pointer' : '', textDecoration: setMarked ? 'underline' : '' }} onClick={() => setMarked && setMarked(`${row.id}`)} >{row.descripcion}</span>
                                </Tooltip>
                            </div>
                            {row.direccion && <span >{row.direccion}</span>}
                            {row.enlace && !row.icon && <a className="custom-link" href={row.enlace}>
                                <span style={{ color: '#147E90' }}>{row.enlace}</span>
                            </a>}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {row.libres && <>
                                <div style={{ width: 10, height: 10, backgroundColor: obtenerNumeroParking( row.libres, row.nivel, row.forzadura ).color, marginRight: 5 }} />
                                <span style={{ fontWeight: 'bold', width: 50, display: 'flex', justifyContent: 'space-evenly' }}>{obtenerNumeroParking(row.libres, row.nivel, row.forzadura ).libres}</span>
                            </>
                            }
                            {row.carga !== undefined &&
                                <span style={{ display: 'flex', alignItems: 'center', marginRight: '50px', minWidth: '150px' }}>
                                    <CircleIcon sx={{ color: obtenerEstadoTrafico(row.carga, nivelTrafico).color, marginRight: '20px' }} />
                                    <span>{obtenerEstadoTrafico(row.carga, nivelTrafico).nombre}</span>
                                </span>
                            }
                            {
                                row.imagen && <img
                                    src={`${row.imagen}.png`}
                                    style={{ width: '40px' }}
                                    className="incidencia-image"
                                    alt="Incidencia Imagen"
                                />
                            }
                        </div>
                    </TableCell>
                ))}
                <div style={{ height: setMarked || tipo ? '15px' : '8px' }}></div>
                {tableInfoAux.length > 8 && width < 1300 && (
                    <TablePagination
                        rowsPerPageOptions={[8]}
                        component="div"
                        count={tableInfoAux.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            width: '100%',
                            '& .MuiTablePagination-actions': {
                                color: principalColor,
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-selectIcon, & .MuiTablePagination-input, & .MuiTablePagination-displayedRows': {
                                color: principalColor,
                            },
                        }}
                    />
                )}
            </Box>
        </div>
    );
}

export default TablaEspecial;
